import React from "react";

export const Testimonials = (props) => {
  return (
    <div id="our-approach">
      <div className="container">
        <div className="section-title text-center">
          <h2>Our Approach</h2>
          <p>Crestpeak Global follows a collaborative and analytical approach:</p>
        </div>
        
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                
                <div key={`${d.name}-${i}`} className="col-md-6">
                  {/* <div className="testimonial">
                    <div className="testimonial-image">
                      {" "}
                      <img src={d.img} alt="" />{" "}
                    </div>
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta"> - {d.name} </div>
                    </div>
                  </div> */}
                    {" "}
                  <div style={{ marginBottom: '30px' }}>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
